import { z } from 'zod/mini'
import { apiFetch } from './client'

export const userSchema = z.object({
  id: z.string(),
  email: z.string(),
  display_name: z.string(),
  timezone: z.string(),
  roles: z.array(z.string()),
  needs_role_selection: z.boolean(),
  created_at: z.string(),
})

export const sessionSchema = z.object({
  access_token: z.string(),
  token_type: z.string(),
  expires_in: z.number(),
  user: userSchema,
  is_new_user: z.boolean(),
})

const providersSchema = z.object({ google: z.boolean(), email_otp: z.boolean() })

export const getProviders = () => apiFetch('/api/v1/auth/providers', { schema: providersSchema })

export const requestOtp = (email) => apiFetch('/api/v1/auth/otp/request', { method: 'POST', body: { email } })

export const verifyOtp = (email, code) =>
  apiFetch('/api/v1/auth/otp/verify', { method: 'POST', body: { email, code }, schema: sessionSchema })

/** Exchange the httpOnly refresh cookie for a new access token (and a rotated cookie). */
export const refreshSession = () => apiFetch('/api/v1/auth/refresh', { method: 'POST', schema: sessionSchema })

export const logout = () => apiFetch('/api/v1/auth/logout', { method: 'POST' })

export const logoutAll = () => apiFetch('/api/v1/auth/logout-all', { method: 'POST' })
